import OutflowGrid from "@/components/OutflowGrid";

export default function CommittedLands() {
  return (
    <OutflowGrid
      page="committed_lands"
      testId="outflows-committed-lands"
      kicker="Outflows"
      title="Committed for New Lands"
      editRole="finance"
      description="Committed cash outlays for new land acquisitions (Hagadur, Noombal, Thaiyur, Attur, Mangadu) + FSI premium commitments. Amounts in ₹ Lakhs."
    />
  );
}
